import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=299e040d&"
import script from "./Events.vue?vue&type=script&lang=ts&"
export * from "./Events.vue?vue&type=script&lang=ts&"
import style0 from "./Events.vue?vue&type=style&index=0&id=299e040d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports